import { Aggregator, AngularSlickgridComponent, SlickGrid, GridService, Column } from 'angular-slickgrid';
import { AnyHandler, AggregatorTotalsHandler } from 'src/app/types/@types/sl-v-types';
import { NonBlockingIterator } from '../non-blocking-iterator';
import { SLAggregator } from './slaggregator';


export class StdDevAggregator extends SLAggregator {
	protected _name = 'stddev';
	protected _label = 'STD'
	private _mean: any = undefined;
	private _count: number;
	private totals: any;
	private GetStats(column: Column<any>) {
		return column.params.stats;
	}
	constructor() {
		super();
		this.groupable = false;
		this.requiresInvalidation = true;
	}
	init() {
		super.init();
		this._value = {};
		this._mean = {};
		this._count = 0;

		//this._column.params.stats = [];

	}
	Accumulate(item: any, column: Column<any>) {

		if (!this._mean[column.id]) {
			this._mean[column.id] = Number(item[column.id]);
		} else {
			this._mean[column.id] += Number(item[column.id]);
		}
		this._count += 1;
	}

	SetTotals(totals: any, completeHandler?: AggregatorTotalsHandler) {
		if (!totals.group) {
			return;
		}
		this.totals = totals;
		const records = totals.group.rows;
		this.InitTotals(totals);

		if (this._count === 0) {
			return;
		}
		const variances = {};
		for (const column of this._columns) {
			if (this._count === 1) {
				totals[this._name][column.id] = 0;
			}
			const mean = this._mean[column.id] / this._count;

			variances[column.id] = 0;

			new NonBlockingIterator(records, (result) => {
				this._value[column.id] = Math.pow(variances[column.id], .5);
				super.SetTotals(totals);
				// Only do this for the totals row?
				if (!!completeHandler) {
					new NonBlockingIterator(records, (zResult) => {
						this.EndAggregation(totals, completeHandler);
					}).ForEach((zRecord) => {
						const zScore = ((Number(zRecord.item[column.id]) - mean) / this._value[column.id]);
						(zRecord.item.__stats[column.id] as any).zScore = zScore;
					});
				}
			}).ForEach((record) => {
				const v = Math.pow(Number(record.item[column.id]) - mean, 2);
				variances[column.id] += (v / (this._count - 1));
				if (!record.item.__stats) {
					record.item.__stats = {};
				}
				if (!record.item.__stats[column.id]) {
					(record.item.__stats as any)[column.id] = {};
				}
				(record.item.__stats[column.id] as any)[this._name] = NaN;

				// variance is a variable defined before the iterator loop, this closure
				// iteratively increases the variance value which is then used when the loop
				// completes in the result handler/closure above to compute std dev.
			});
		}
	}
	ColumnRemoved(columnDef: Column<any>) {
		if (!!this.totals && this.totals.group && this.totals.group.rows) {
			for (const row of this.totals.group.rows) {
				if(!!row.__stats) {
					if(!!row.__stats[columnDef.id]) {
						delete row.__stats[columnDef.id];
					}
				}
			}
		}
	}
}